/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum OfferingType {
    ProductSubscriptionHomeExtensionConfigurator = 0,
    ProductSubscriptionDormerConfigurator = 1,
    ProductSubscriptionDormerConfiguratorPro = 2,
}
